import React, { useState } from 'react'
import classNames from 'classnames'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const MobileNav = ({ showSidebar, setShowSidebar }) => (
  <nav className="bg-secondary px-4 text-gray-100 flex justify-between lg:hidden">
    <h1 className="font-laila font-black text-2xl">
      <Link to="/" className="flex justify-center">
        TeyvatGuide
      </Link>
    </h1>
    <button
      onClick={() => setShowSidebar(!showSidebar)}
      className="mobile-menu-button p-4 focus:outline-none focus:bg-gray-700"
    >
      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  </nav>
)

const MenuItem = ({ item, isActive }) => (
  <li
    className={classNames('p-4', {
      'bg-blue-900': isActive,
    })}
  >
    <Link to={item.path} className="flex items-center">
      <GatsbyImage image={getImage(item.image)} alt={item.name} className="mr-4 opacity-75" />
      <span
        className={classNames('text-2xl capitalize', {
          'text-gray-500': !isActive,
          'text-white': isActive,
        })}
      >
        {item.name}
      </span>
    </Link>
  </li>
)

const Sidebar = ({ location }) => {
  const { allFile } = useStaticQuery(
    graphql`
      query {
        allFile(filter: { dir: {}, relativeDirectory: { eq: "sidebar" } }) {
          nodes {
            name
            childImageSharp {
              gatsbyImageData(placeholder: NONE, height: 32, width: 32)
            }
          }
        }
      }
    `
  )
  const menuItems = [
    {
      name: 'home',
      path: '/',
      image: allFile.nodes.find((image) => image.name === 'home'),
    },
    {
      name: 'articles',
      path: '/articles',
      image: allFile.nodes.find((image) => image.name === 'articles'),
    },
    {
      name: 'guides',
      path: '/guides',
      image: allFile.nodes.find((image) => image.name === 'guides'),
    },
    {
      name: 'changelog',
      path: '/changelog',
      image: allFile.nodes.find((image) => image.name === 'changelog'),
    },
    {
      name: 'about',
      path: '/about',
      image: allFile.nodes.find((image) => image.name === 'about'),
    },
  ]

  const activeMenuItem = location?.pathname?.split('/')[1] || 'home'
  const [showSidebar, setShowSidebar] = useState(false)

  return (
    <>
      <MobileNav showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div
        className={classNames(
          'z-10 transform transition duration-200 ease-in-out w-60 flex flex-col lg:translate-x-0 justify-between h-full fixed bg-secondary',
          {
            ' -translate-x-full': !showSidebar,
            'translate-x-0': showSidebar,
          }
        )}
      >
        <nav>
          <h1 className="font-laila font-black text-2xl">
            <Link to="/" className="flex justify-center">
              TeyvatGuide
            </Link>
          </h1>
          <ul>
            {menuItems.map((menuItem) => (
              <MenuItem key={menuItem.name} item={menuItem} isActive={menuItem.name === activeMenuItem} />
            ))}
          </ul>
        </nav>
        <div className="m-4 flex justify-center">
          <Link to="/privacy">Privacy</Link>
        </div>
      </div>
    </>
  )
}

export default Sidebar
